import script from "./IncomeAcctStmentFund.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeAcctStmentFund.vue?vue&type=script&setup=true&lang=js"

import "./IncomeAcctStmentFund.vue?vue&type=style&index=0&id=85737e7a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85737e7a"]])

export default __exports__